module.exports = __webpack_public_path__ + "img/video.13251ee0.png";